@if (literature; as lit) {
  <article class="literature-card page-item" role="article" [attr.aria-label]="lit.title">
    <div class="thumb">
      <a [href]="lit.documentLink || lit.url" target="_blank" rel="noopener">
        <img [src]="thumbnailSrc" [alt]="lit.title" loading="lazy" />
      </a>
    </div>
    <div class="form-number">
      <small> {{ 'contentPages.pageItem.form' | cxTranslate }} {{ lit.publicationNumber }}</small>
    </div>
    <div class="category">
      <small>{{ lit.category }}</small>
    </div>
    <h3 class="title">{{ lit.title }}</h3>
    <div class="cta">
      <a class="btn btn-primary download-btn w-100" [href]="lit.documentLink || lit.url" target="_blank" rel="noopener">{{
        'contentPages.pageItem.download' | cxTranslate
      }}</a>
    </div>
  </article>
}
